import { ArrayParam, useQueryParam, withDefault } from 'use-query-params';

export const OPTIONS = [
  {
    label: 'Day shift',
    value: 'day',
  },
  {
    label: 'Night shift',
    value: 'night',
  },
  {
    label: 'Evening',
    value: 'evening',
  },
];

interface IUseSchedule {
  schedule: string[];
  setSchedule: (schedule: string[]) => void;
  clearSchedule: () => void;
  hasSchedule: boolean;
}

const EMPTY_SCHEDULE: string[] = [];

export const useSchedule = (): IUseSchedule => {
  const [schedule, setQuery] = useQueryParam('schedule', withDefault(ArrayParam, EMPTY_SCHEDULE));

  const clearSchedule = () => setQuery(undefined, 'replaceIn');

  const setSchedule = (schedule: string[]) =>
    schedule?.length ? setQuery(schedule, 'replaceIn') : clearSchedule();

  return {
    schedule: [...schedule].filter((value): value is string => value !== null),
    setSchedule,
    clearSchedule,
    hasSchedule: !!schedule?.length,
  };
};

export default useSchedule;
